/**
 * 创建store 然后需要在main.js里全局注册
 */
import Vue from 'vue';
import Vuex from 'vuex';
import state from './state.js';
import * as types from './mutation-types';
import * as getters from './getters.js';
import mutations from './mutations.js';
import actions from './actions.js';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production'; // 开发环境中为true，否则为false
const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state,
  getters,
  mutations,
  actions
});

Object.defineProperty(store, 'types', {
  get () {
    return types;
  }
});
export default store;
